// extracted by mini-css-extract-plugin
export var infoItem = "_o5-2";
export var title = "_o5-0";
export var value = "_o5-1";